<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #ece7e0;">
          <h5 class="card-title">Gestión de Tramites</h5>
          <div class="row mb-3" style="margin: 0px 0px 0px -10px; padding: -10px;">
            <div class="col-md-2">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Gestion: </label>
                  <select 
                    v-model="filters.gestion" 
                    class="form-select"
                  >
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <div class="input-group">
                  <template v-if="hasPermission('distri_create')">
                    <div class="form-control readonly-field">
                      {{ distrital.unidad }}
                      <input type="hidden" v-model="filters.id_unidad">
                    </div>
                  </template>
                  <template v-else>
                    <select 
                      v-model="filters.id_unidad" 
                      class="form-select" 
                      @change="(e) => { console.log('Cambió unidad:', e.target.value); fetchAreas() }"
                    >
                      <option value="">Todas las unidades</option>
                      <option 
                        v-for="unidad in unidades" 
                        :key="unidad.id" 
                        :value="unidad.id"
                      >
                        {{ unidad.nombre_unidad }} ({{ unidad.codigo }})
                      </option>
                    </select>
                  </template>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <div class="input-group">
                  <template v-if="hasPermission('distri_create')">
                    <div class="form-control readonly-field">
                      {{ distrital.area }}
                      <input type="hidden" v-model="filters.id_area">
                    </div>
                  </template>
                  <template v-else>
                    <select 
                      v-model="filters.id_area" 
                      class="form-select"
                    >
                      <option value="">Todas las secciones</option>
                      <option 
                        v-for="area in areas" 
                        :key="area.id" 
                        :value="area.id"
                      >
                        ({{ area.codigo }}) {{ area.nombre_area }} 
                      </option>
                    </select>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3" style="margin: -20px 0px -10px 0px; padding: -10px;">
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Etapa: </label>
                  <select 
                    v-model="filters.etapa" 
                    class="form-select"
                  >
                    <option value="Todos">Todos</option>
                    <option value="Recepcion">Recepcion</option>
                    <option value="Evaluacion">Evaluacion</option>
                    <option value="Aprobacion">Aprobacion</option>
                    <option value="Entrega">Entrega</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Estado: </label>
                  <select 
                    v-model="filters.estado" 
                    class="form-select"
                  >
                    <option value="Todos">Todos</option>
                    <option v-if="hasPermission('distri_create')" value="Recepcionado">Recepcionado</option>
                    <option value="Recibido">Recibido</option>
                    <option value="Derivado">Derivado</option>
                    <option value="Observado">Observado</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Desde: </label>
                  <input
                    type="date"
                    v-model="filters.desde"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Hasta: </label>
                  <input
                    type="date"
                    v-model="filters.hasta"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3" style="margin: -20px 0px -20px 0px; padding: -10px;">
            <div class="col-md-3">
              <div class="form-group">
                <div class="input-group">
                  <label class="form-label">Filtrar por: </label>
                  <select 
                    v-model="filters.bpor" 
                    class="form-select"
                  >
                    <option value="">-- Buscar Por --</option>
                    <option value="codigo">Codigo</option>
                    <option value="solicitante">Solicitante</option>
                    <option value="tipotramite">Tipo Tramite</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="filters.criterio"
                    class="form-control"
                    required
                  />
                  <button 
                    class="btn btn-outline-secondary" 
                    type="button" 
                    @click="handleSearch"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>

              </div>
            </div>
            <div class="col-md-4">
              <BButton
                v-if="hasPermission('tramite_create')"
                @click="showModal(null)"
                variant="primary"
                class="btn-round btn-sm me-2"
              >
                <i class="fa fa-plus me-1"></i> Nuevo Tramite
              </BButton>
              <!--
              <BButton
                v-if="hasPermission('tramite_create')"
                variant="danger"
                class="btn-round btn-sm"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
              -->
              <BButton
                v-if="hasPermission('tramite_create')"
                variant="danger"
                class="btn-round btn-sm me-2"
                @click="generateSelectedPDF"
                :disabled="selectedTramites.length === 0"
              >
                <i class="fa fa-print me-1"></i> PDF Derivar
              </BButton>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered" style="font-size: 0.8rem;">
                <thead class="text-primary">
                  <tr style="line-height: 8px;">
                    <th>CHK</th>
                    <th>Codigo</th>
                    <th>Tipo Tramite</th>
                    <th>Solicitado por</th>
                    <th>Gestion</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tramite in tramites" :key="tramite.id">
                    <td>
                      <input 
                        type="checkbox" 
                        v-model="selectedTramites" 
                        :value="tramite.id"
                        class="form-check-input"
                      >
                    </td>
                    <td>{{ tramite.codigo }}</td>
                    <td>{{ tramite.tipo_tramite }}</td>
                    <td>{{ tramite.nombres }} {{ tramite.paterno }} {{ tramite.materno }}</td>
                    <td>{{ tramite.gestion }}</td>
                    <td>
                      <BBadge :variant="tramite.recepcion === 'Recibido' ? 'success' : 'warning'">
                        {{ tramite.recepcion }}
                      </BBadge>
                    </td>
                    <td>{{ tramite.fecha_formateada }}</td>
                    <td>
                      <div class="btn-group">
                        <BButton
                          variant="danger"
                          class="btn-round btn-sm"
                          @click="generateFormPDF(tramite.id)"
                        >
                          <i class="fa fa-file-pdf me-1"></i>
                        </BButton>
                        <router-link 
                          :to="`/tramite/detail/${tramite.id}`" 
                          class="btn btn-sm btn-success"
                        >
                          <i class="fa fa-folder-open"></i>
                        </router-link>
                        <BButton
                          v-if="hasPermission('tramite_update') && tramite.recepcion == 'Recibido'"
                          @click="showModal(tramite)"
                          variant="warning"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-edit"></i>
                        </BButton>
                        <BButton
                          v-if="hasPermission('tramite_delete')"
                          @click="confirmDelete(tramite)"
                          variant="danger"
                          size="sm"
                        >
                          <i class="fa fa-trash"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Paginación -->
            <div class="row mt-3" v-if="pagination.total > 0">
              <div class="col-md-12">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  @input="handlePageChange"
                  align="center"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="lg"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleSubmit">
        <div class="row mt-3" v-if="!hasPermission('distri_create')">
          <label class="form-label col-md-2">Modo:</label>
          <div class="col-md-10">
            <div class="form-group">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="form.modo"
                  id="modo_nuevo"
                  value="nuevo"
                >
                <label class="form-check-label" for="modo_nuevo">Nuevo</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="form.modo"
                  id="modo_reingreso"
                  value="reingreso"
                >
                <label class="form-check-label" for="modo_reingreso">Reingreso</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <label class="form-label col-md-2">Codigo:</label>
          <div class="col-md-4">
            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  type="text"
                  v-model="form.codigo"
                  class="form-control"
                  :class="{ 'is-invalid': errors.codigo }"
                  required
                  :readonly="form.modo == 'nuevo'"
                />
                <button
                  v-if="form.modo !== 'nuevo'"
                  class="btn btn-outline-secondary" 
                  type="button"
                  @click="searchByCodigo"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
              <div class="invalid-feedback" v-if="errors.codigo">
                {{ errors.codigo[0] }}
              </div>
            </div>
          </div>
          <label class="form-label col-md-2">Gestion:</label>
          <div class="col-md-4">
            <div class="form-group">
              <input
                type="text"
                v-model="form.gestion"
                class="form-control"
                :class="{ 'is-invalid': errors.gestion }"
                readonly
                required
              />
              <div class="invalid-feedback" v-if="errors.gestion">
                {{ errors.gestion[0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <label class="form-label col-md-2">Unidad:</label>
          <div class="col-md-10">
            <div class="form-group">
              
                <select
                  v-model="form.unidad"
                  class="form-select" 
                  :class="{ 'is-invalid': errors.unidad }"
                  @change="(e) => { console.log('Cambió unidad:', e.target.value); fetchTipotramitesunidad(e.target.value,0) }"
                >
                  <option value="">Seleccione Unidad</option>
                  <option 
                    v-for="unidad in unidades" 
                    :key="unidad.id" 
                    :value="unidad.id"
                  >
                    {{ unidad.nombre_unidad }}
                  </option>
                </select>
                    
              <div v-if="errors.unidad" class="invalid-feedback">
                {{ errors.unidad[0] }}
              </div>
              <div v-if="loadingUnidades" class="text-muted small">
                Cargando unidades...
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <label class="form-label col-md-2">Tipo Tramite:</label>
          <div class="col-md-10">
            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  type="text"
                  v-model="tipoSearch"
                  class="form-control"
                  placeholder="Buscar por Tipo de Tramite"
                  @input="searchByTipo"
                  :readonly="form.unidad == ''"
                />
              </div>
              <!-- Resultados de la búsqueda tipo tramite -->
              <div v-if="searchResultsTipo.length > 0" class="search-results">
                <div 
                  v-for="tipoTramite in searchResultsTipo" 
                  :key="tipoTramite.id"
                  class="search-result-item"
                  :class="{ 'selected': form.id_tipo_tramite === tipoTramite.id }"
                  @click="selectTipotramite(tipoTramite)"
                >
                  {{ tipoTramite.tipo }} 
                  ( {{ tipoTramite.tipo_etapa === 1 ? 'Común' : tipoTramite.tipo_etapa === 2 ? 'Legal' : tipoTramite.tipo_etapa === 3 ? 'Firma' : tipoTramite.tipo_etapa === 4 ? 'Valores' : tipoTramite.tipo_etapa === 5 ? 'MinEdu' : 'desconocido' }} )
                </div>
              </div>

              <!-- Mostrar tipo tramite seleccionada -->
              <div v-if="form.id_tipo_tramite && selectedTipotramite" class="selected-persona">
                <strong>Seleccionado:</strong> 
                {{ selectedTipotramite.tipo }} (Tipo: {{ selectedTipotramite.tipo_etapa }})
              </div>
              <!--
              <select
                v-model="form.id_tipo_tramite"
                class="form-select" 
                :class="{ 'is-invalid': errors.id_tipo_tramite }"
                :disabled="loadingTipotramites"
              >
                <option value="">Seleccione tipo tramite</option>
                <option 
                  v-for="tipotramite in tipotramites" 
                  :key="tipotramite.id" 
                  :value="tipotramite.id"
                >
                  {{ tipotramite.tipo }}
                </option>
              </select>
                 
              <div v-if="errors.id_tipo_tramite" class="invalid-feedback">
                {{ errors.id_tipo_tramite[0] }}
              </div>
              <div v-if="loadingTipotramites" class="text-muted small">
                Cargando tipo de tramites...
              </div>
              -->   
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <label class="form-label col-md-2">Solicitado Por:</label>
          <div class="col-md-10">
            <div class="form-group">
              <!-- Buscador por CI -->
              <div class="input-group mb-3">
                <input
                  type="text"
                  v-model="ciSearch"
                  class="form-control"
                  placeholder="Buscar por Número de CI"
                  @input="searchByCI"
                />
              </div>

              <!-- Resultados de la búsqueda -->
              <div v-if="searchResults.length > 0" class="search-results">
                <div 
                  v-for="persona in searchResults" 
                  :key="persona.id"
                  class="search-result-item"
                  :class="{ 'selected': form.id_solicitante === persona.id }"
                  @click="selectPersona(persona)"
                >
                  {{ persona.nombres }} {{ persona.paterno }} {{ persona.materno }} - CI: {{ persona.carnet_identidad }}
                </div>
              </div>

              <!-- Mostrar persona seleccionada -->
              <div v-if="form.id_solicitante && selectedPersona" class="selected-persona">
                <strong>Seleccionado:</strong> 
                {{ selectedPersona.nombres }} {{ selectedPersona.paterno }} {{ selectedPersona.materno }} 
                (CI: {{ selectedPersona.carnet_identidad }})
              </div>

              <div v-if="errors.id_solicitante" class="invalid-feedback">
                {{ errors.id_solicitante[0] }}
              </div>
            </div>
          </div>
        </div>
        

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed, watch } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BBadge, BPagination } from 'bootstrap-vue-3';

interface Tramite {
  id: number;
  id_tipo_tramite: number;
  id_solicitante: number;
  id_uniad: number;
  unidad: number;
  gestion: number;
  codigo: string;
}

interface FormData {
  id: number | null;
  modo: string;
  id_tipo_tramite: number;
  unidad: number;
  id_solicitante: number;
  gestion: number;
  codigo: string;
}

interface Filters {
  id_unidad: string;
}

interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export default {
  components: {
    BModal,
    BButton,
    BBadge,
    BPagination
  },
  setup() {
    const tramites = ref<Tramite[]>([]);
    const loading = ref(true);
    const unidades = ref<Unidad|[]>([]);
    const distrital = ref<Distrital|[]>([]);
    const loadingUnidades = ref(true);
    const loadingDistrital = ref(true);
    const areas = ref<Area|[]>([]);
    const loadingAreas = ref(true);
    const tipotramites = ref<Tipotramite[]>([]);
    const loadingTipotramites = ref(true);
    const personas = ref<Persona[]>([]);
    const selectedTramites = ref<number[]>([]);
    const loadingPersonas = ref(true);
    const authStore = useAuthStore();
    const estadoInicial = () => {
      const hasDistriCreate = authStore.user?.permissions?.includes('distri_create');
      return hasDistriCreate ? 'Recepcionado' : 'Recibido';
    };
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const filters = ref<Filters>({
      id_unidad: '',
      id_area: '',
      bpor: '',
      criterio: '',
      gestion: ref(new Date().getFullYear()),
      etapa: 'Recepcion',
      estado: estadoInicial(),
      desde: firstDay.toISOString().split('T')[0],
      hasta: today.toISOString().split('T')[0]
    });
    
    // Variables para el modal
    const modalVisible = ref(false);
    const isEditing = ref(false);
    const loadingForm = ref(false);
    const errors = ref<Record<string, string[]>>({});
    // Nuevas variables para el buscador por CI
    //const distrital = ref(null); // Inicializar como null

    const codigoSearch = ref('');
    const searchResultsCodigo = ref<Tramite[]>([]);
    const searchingCodigo = ref(false);

    const ciSearch = ref('');
    const searchResults = ref<Persona[]>([]);
    const selectedPersona = ref<Persona | null>(null);
    const searching = ref(false);

    const tipoSearch = ref('');
    const searchResultsTipo = ref<Persona[]>([]);
    const selectedTipotramite = ref<Persona | null>(null);
    const searchingTipo = ref(false);
    
    const form = ref<FormData>({
      id: null,
      modo: 'nuevo',
      unidad: '',
      id_tipo_tramite: '',
      id_solicitante: '',
      gestion: ref(new Date().getFullYear()),
      codigo: '',
    });

    // Paginación
    const pagination = ref<Pagination>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const modalTitle = computed(() => {
      return isEditing.value ? 'Editar Tramite' : 'Nuevo Tramite';
    });

    //searchByCodigo
    const searchByCodigo = async () => {
      if (!form.value.codigo.trim()) {
        searchResultsCodigo.value = [];
        Swal.fire({
          icon: 'warning',
          title: 'Código vacío',
          text: 'Por favor ingrese un código para buscar'
        });
        return;
      }

      searchingCodigo.value = true;
      try {
        const response = await axios.get('/tramite/search', {
          params: { codigo: form.value.codigo }
        });
        
        searchResultsCodigo.value = response.data.tramite || response.tramite || [];
        console.log(searchResultsCodigo.value);
        if (searchResultsCodigo.value) {
          const tramite = searchResultsCodigo.value;
          await loadTramiteData(tramite);
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'No encontrado',
            text: 'No se encontró ningún trámite con el código: ' + form.value.codigo
          });
        }
      } catch (error) {
        console.error('Error al buscar trámite:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo buscar el trámite'
        });
      } finally {
        searchingCodigo.value = false;
      }
    };

    const loadTramiteData = async (tramite: Tramite) => {
      try {
        // Cargar tipos de trámite para la unidad del trámite encontrado
        await fetchTipotramitesunidad(tramite.id_unidad, tramite.id_tipo_tramite);        
        // Buscar la persona solicitante
        if (tramite.id_solicitante) {
          const personaExistente = personas.value.find(p => p.id === tramite.id_solicitante);
          if (personaExistente) {
            selectedPersona.value = personaExistente;
            ciSearch.value = personaExistente.carnet_identidad || '';
          }
        }
        
        // Llenar el formulario con los datos del trámite
        isEditing.value = true;
        form.value = {
          id: tramite.id,
          modo: 'reingreso',
          codigo: tramite.codigo,
          unidad: tramite.id_unidad,
          id_tipo_tramite: tramite.id_tipo_tramite,
          id_solicitante: tramite.id_solicitante,
          gestion: tramite.gestion
        };
        
        // Establecer modo como reingreso
        form.value.modo = 'reingreso';
        
        Swal.fire({
          icon: 'success',
          title: 'Trámite encontrado',
          text: 'Los datos del trámite han sido cargados'
        });
        
      } catch (error) {
        console.error('Error al cargar datos del trámite:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar todos los datos del trámite'
        });
      }
    };
    // Método para buscar personas por CI
    const searchByCI = async () => {
      if (!ciSearch.value.trim()) {
        searchResults.value = [];
        return;
      }

      searching.value = true;
      try {
        const response = await axios.get('/persona/search', {
          params: { ci: ciSearch.value }
        });
        searchResults.value = response.data.personas || [];
      } catch (error) {
        console.error('Error al buscar personas:', error);
        searchResults.value = [];
      } finally {
        searching.value = false;
      }
    };

    const searchByTipo = async () => {
      console.log(form.value.unidad);
      if (!tipoSearch.value.trim()) {
        searchResultsTipo.value = [];
        return;
      }

      searchingTipo.value = true;
      try {
        const response = await axios.get('/tipotramite/search', {
          params: { 
            tipo: tipoSearch.value,
            unidad: form.value.unidad

          }
        });
        searchResultsTipo.value = response.data.tipotramites || [];
      } catch (error) {
        console.error('Error al buscar tipo de tramites:', error);
        searchResultsTipo.value = [];
      } finally {
        searchingTipo.value = false;
      }
    };

    // Método para seleccionar un tipo de tramite
    const selectTipotramite = (tipoTramite: TipoTramite) => {
      form.value.id_tipo_tramite = tipoTramite.id;
      selectedTipotramite.value = tipoTramite;
      searchResultsTipo.value = [];
      tipoSearch.value = '';
    };
    // Método para seleccionar una persona de los resultados
    const selectPersona = (persona: Persona) => {
      form.value.id_solicitante = persona.id;
      selectedPersona.value = persona;
      searchResults.value = [];
      ciSearch.value = '';
    };

    const showModal = (tramite: Tramite | null) => {
      errors.value = {};
      searchResults.value = [];
      ciSearch.value = '';
      selectedPersona.value = null;

      if (tramite) {
        // Edición
        fetchTipotramitesunidad(tramite.id_unidad,tramite.id_tipo_tramite);
        isEditing.value = true;
        form.value = {
          id: tramite.id,
          modo: 'nuevo',
          codigo: tramite.codigo,
          unidad: tramite.id_unidad,
          id_tipo_tramite: tramite.id_tipo_tramite,
          id_solicitante: tramite.id_solicitante,
          gestion: tramite.gestion
        };
        console.log(tipotramites);
        if (tramite.id_tipo_tramite) {
            const tipo = tipotramites.value.find(t => t.id === tramite.id_tipo_tramite);
            console.log(tipo);
            if (tipo) {
              selectedTipotramite.value = tipo;
            }
        }
        if (tramite.id_solicitante) {
          const persona = personas.value.find(p => p.id === tramite.id_solicitante);
          if (persona) {
            selectedPersona.value = persona;
          }
        }
      } else {
        // Nuevo
        isEditing.value = false;
        form.value = {
          id: null,
          modo: 'nuevo',
          codigo: '',
          unidad: '',
          id_tipo_tramite: '',
          id_solicitante: '',
          gestion: ref(new Date().getFullYear()),
        };
      }
      modalVisible.value = true;
    };

    const handleSubmit = async () => {
      loadingForm.value = true;
      errors.value = {};
      
      try {
        let response;
        
        if (isEditing.value && form.value.id) {
          response = await axios.post(`/tramite/update/${form.value.id}`, form.value);
        } else {
          response = await axios.post('/tramite/save', form.value);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        modalVisible.value = false;
        fetchTramite();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingForm.value = false;
      }
    };

    const fetchDistrital = async () => {
      try {
        const response = await axios.get('/distrital/select');
        distrital.value = response.data.distrital;
        if (hasPermission('distri_create') && distrital.value && distrital.value.id_area) {
          filters.value.id_unidad = distrital.value.id_unidad;
          filters.value.id_area = distrital.value.id_area;
        }
        
      } catch (error) {
        console.error('Error al cargar unidades:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar la distrital'
        });
      } finally {
        loadingDistrital.value = false;
      }
    };

    const fetchUnidades = async () => {
      try {
        const response = await axios.get('/unidad/select');
        unidades.value = response.data.unidades;
      } catch (error) {
        console.error('Error al cargar unidades:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las unidades organizacionales'
        });
      } finally {
        loadingUnidades.value = false;
      }
    };

    const fetchAreas = async () => {
      console.log('Iniciando fetchAreas, id_unidad:', filters.value.id_unidad);
      if (!filters.value.id_unidad) {
        areas.value = []; // Limpiar áreas si no hay unidad seleccionada
        filters.id_area = ''; // Resetear el área seleccionada
        return;
      }

      loadingAreas.value = true;
      try {
        const response = await axios.get('/area/select', {
          params: { id_unidad: filters.value.id_unidad }
        });
        areas.value = response.data.areas || [];
      } catch (error) {
        console.error('Error al cargar secciones:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las secciones funcionales'
        });
      } finally {
        loadingAreas.value = false;
      }
    };
    
    const fetchTipotramitesunidad = async (unidad: number, tipo_tramite: number = 0) => {
      console.log('Iniciando fetchTipotramitesunidad, unidad:', unidad);
      
      if (!unidad) {
        tipotramites.value = [];
        form.value.id_tipo_tramite = '';
        selectedTipotramite.value = null;
        return;
      }
      
      loadingTipotramites.value = true;
      try {
        const response = await axios.get(`/tipotramite/select_unidad/${unidad}`);
        tipotramites.value = response.data.tipotramites || [];
        
        // Solo establecer el tipo de trámite si se proporciona y existe en la lista
        if (tipo_tramite !== 0) {
          const tipoExistente = tipotramites.value.find(t => t.id === tipo_tramite);
          if (tipoExistente) {
            form.value.id_tipo_tramite = tipo_tramite;
            selectedTipotramite.value = tipoExistente;
            tipoSearch.value = tipoExistente.tipo;
          } else {
            form.value.id_tipo_tramite = '';
            selectedTipotramite.value = null;
            tipoSearch.value = '';
          }
        }
      } catch (error) {
        console.error('Error al cargar tipos de trámites:', error);
        tipotramites.value = [];
        form.value.id_tipo_tramite = '';
        selectedTipotramite.value = null;
        tipoSearch.value = '';
      } finally {
        loadingTipotramites.value = false;
      }
    };

    watch(() => form.value.unidad, async (newUnidadId) => {
      if (newUnidadId) {
        await fetchTipotramitesunidad(newUnidadId);
      } else {
        tipotramites.value = [];
        form.value.id_tipo_tramite = '';
        selectedTipotramite.value = null;
        tipoSearch.value = '';
      }
    });

    const getTipoEtapaText = (tipoEtapa: number) => {
      const tipos = {
        1: 'Común',
        2: 'Legal', 
        3: 'Firma',
        4: 'Valores',
        5: 'MinEdu'
      };
      return tipos[tipoEtapa] || 'Desconocido';
    };
    const fetchTipotramites = async () => {
      try {
        const response = await axios.get('/tipotramite/select');
        tipotramites.value = response.data.tipotramites;
      } catch (error) {
        console.error('Error al cargar tipos de tramites:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los tipos de tramites'
        });
      } finally {
        loadingTipotramites.value = false;
      }
    };

    const fetchPersonas = async () => {
      loadingPersonas.value = true;
      try {
        const response = await axios.get('/persona/select');
        personas.value = response.data.personas || [];
      } catch (error) {
        console.error('Error al cargar personas:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar las personas'
        });
      } finally {
        loadingPersonas.value = false;
      }
    };

    const fetchTramite = async () => {
      loading.value = true;
      console.log(filters);
      try {
        const params: Record<string, any> = {
          page: pagination.value.current_page,
          per_page: pagination.value.per_page
        };
        
        if (filters.value.id_unidad) {
          params.id_unidad = filters.value.id_unidad;
        }
        if (filters.value.id_area) {
          params.id_area = filters.value.id_area;
        }
        if (filters.value.bpor) {
          params.bpor = filters.value.bpor;
        }
        if (filters.value.criterio) {
          params.criterio = filters.value.criterio;
        }
        if (filters.value.gestion) {
          params.gestion = filters.value.gestion;
        }
        if (filters.value.etapa) {
          params.etapa = filters.value.etapa;
        }
        if (filters.value.estado) {
          params.estado = filters.value.estado;
        }
        if (filters.value.desde) {
          params.desde = filters.value.desde;
        }
        if (filters.value.hasta) {
          params.hasta = filters.value.hasta;
        }
        
        const response = await axios.get('/tramite/list', { params });
        tramites.value = response.data.tramites.data || response.data.tramites;
        
        // Actualizar paginación si la API la soporta
        if (response.data.tramites.meta) {
          pagination.value = {
            current_page: response.data.tramites.meta.current_page,
            per_page: response.data.tramites.meta.per_page,
            total: response.data.tramites.meta.total,
            last_page: response.data.tramites.meta.last_page
          };
        }
        
      } catch (error) {
        console.error('Error al cargar tramites:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los tramites'
        });
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.value.current_page = 1;
      fetchTramite();
    };

    const handlePageChange = (page: number) => {
      pagination.value.current_page = page;
      fetchTramite();
    };
    
    const confirmDelete = (tramite: Tramite) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar la sección ${tramite.codigo}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deleteTramite(tramite.id);
        }
      });
    };
    
    const deleteTramite = async (id: number) => {
      try {
        await axios.delete(`/tramite/delete/${id}`);
        Swal.fire({
          icon: 'success',
          title: 'Sección eliminada',
          text: 'La sección ha sido eliminada correctamente'
        });
        await fetchTramite();
      } catch (error: any) {
        console.error('Error al eliminar sección:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo eliminar la sección'
        });
      }
    };

    const generateSelectedPDF = () => {
      if (selectedTramites.value.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Sin selección',
          text: 'Por favor seleccione al menos un trámite para generar el PDF'
        });
        return;
      }

      const params = {
        selected_ids: selectedTramites.value.join(','),
        ...(filters.value.id_unidad && { id_unidad: filters.value.id_unidad }),
        ...(filters.value.id_area && { id_area: filters.value.id_area }),
        ...(filters.value.gestion && { gestion: filters.value.gestion }),
      };

      axios.get('/tramite/reporteTramiteSelected', {
        params,
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Abrir en nueva pestaña
        window.open(url, '_blank');
        
        // Limpiar selección después de generar
        selectedTramites.value = [];
        
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF de los trámites seleccionados'
        });
      });
    };

    const generatePDF = () => {
      const params = {
        ...(filters.value.id_unidad && { id_unidad: filters.value.id_unidad }),
        ...(filters.value.id_area && { id_area: filters.value.id_area }),
        ...(filters.value.bpor && { bpor: filters.value.bpor }),
        ...(filters.value.criterio && { criterio: filters.value.criterio }),
        ...(filters.value.gestion && { gestion: filters.value.gestion }),
        ...(filters.value.etapa && { etapa: filters.value.etapa }),
        ...(filters.value.estado && { estado: filters.value.estado }),
        ...(filters.value.desde && { desde: filters.value.desde }),
        ...(filters.value.hasta && { hasta: filters.value.hasta }),
      };
      axios.get('/tramite/reporteTramite', {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        // Crear el blob
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Abrir en nueva pestaña en lugar de descargar
        window.open(url, '_blank');
        
        // Limpiar después de un tiempo (opcional)
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 1000);
        
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };
    
    const generateFormPDF = (id: number) => {
      axios.get(`/tramite/reporte/${id}`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        // Crear el blob
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Abrir en nueva pestaña en lugar de descargar
        window.open(url, '_blank');
        
        // Limpiar después de un tiempo (opcional)
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 1000);
        
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };

    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    /*
    watch(distrital, (newVal) => {
        if (newVal && newVal.id_area) {
            filters.value.id_area = newVal.id_area;
        }
    }, { immediate: true });

    watch(distrital, (newVal) => {
      if (hasPermission('distri_create') && newVal && newVal.id_area) {
          filters.value.id_area = newVal.id_area;
      }
    }, { immediate: true });
    */
    onMounted(() => {
      fetchTramite();
      fetchUnidades();
      //fetchTipotramites();
      fetchPersonas();
      fetchDistrital();
      filters.value.desde = firstDay.toISOString().split('T')[0];
      filters.value.hasta = today.toISOString().split('T')[0];
    });
    
    return {
      tramites,
      unidades,
      loadingUnidades,
      distrital,
      loadingDistrital,
      tipotramites,
      loadingTipotramites,
      personas,
      fetchPersonas,
      loadingPersonas,
      areas,
      fetchTipotramitesunidad,
      fetchAreas,
      filters,
      loading,
      form,
      errors,
      loadingForm,
      isEditing,
      modalTitle,
      modalVisible,
      pagination,
      handleSearch,
      handlePageChange,
      confirmDelete,
      hasPermission,
      showModal,
      handleSubmit,
      generatePDF,
      generateFormPDF,
      selectedTramites,
      generateSelectedPDF,
      ciSearch,
      searchResults,
      selectedPersona,
      searching,
      searchByCI,
      selectPersona,
      tipoSearch,
      searchResultsTipo,
      selectedTipotramite,
      searchingTipo,
      searchByTipo,
      selectTipotramite,
      searchByCodigo,
      codigoSearch,
      searchResultsCodigo,
      searchingCodigo,
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
  .search-results {
    border: 1px solid #ddd;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    margin-bottom: 10px;
  }

  .search-result-item {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
  }

  .search-result-item:hover {
    background-color: #f5f5f5;
  }

  .search-result-item.selected {
    background-color: #e9f7fe;
    font-weight: bold;
  }

  .selected-persona {
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    margin-top: 8px;
  }
  .readonly-field {
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    padding: 0.375rem 0.75rem;
    border-radius: 0.375rem;
    min-height: 38px;
    display: flex;
    align-items: center;
  }
</style>